module.exports = __webpack_public_path__ + "0e44fec897993feede3f2536d4612907.gif";